module.exports = __webpack_public_path__ + "static/media/dog-american-staffordshire-terrier.53b7d169.png";